
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m12 22c2.6525 0 5.1962-1.0536 7.0713-2.9287s2.9287-4.4188 2.9287-7.0713c0-2.65249-1.0536-5.19618-2.9287-7.07129-1.8751-1.8751-4.4188-2.92871-7.0713-2.92871-2.65249 0-5.19618 1.05363-7.07129 2.92871-1.8751 1.87509-2.92871 4.4188-2.92871 7.07129.00327 2.6508 1.05771 5.1928 2.93289 7.0671 1.87428 1.8751 4.41629 2.9296 7.06711 2.9329zm0-18.04809c2.1333 0 4.1803.84765 5.6892 2.35661 1.5089 1.50891 2.3566 3.5548 2.3566 5.68918 0 2.1333-.8468 4.1802-2.3558 5.6892-1.5089 1.5089-3.5548 2.3566-5.6883 2.3574-2.1342 0-4.18028-.8468-5.68983-2.3558-1.5089-1.508-2.35745-3.5547-2.35745-5.6883.00246-2.13333.8501-4.17857 2.35892-5.68666 1.50808-1.5089 3.55311-2.3566 5.68666-2.35891zm.9106 12.94839v.0008c0 .4177-.2526.7945-.6384.9547-.3866.1602-.8313.0711-1.1264-.2239-.2959-.2959-.3841-.7406-.2239-1.1264.1594-.3866.5362-.6384.9547-.6384.2746 0 .5378.1087.7316.3033.1937.1945.3024.4577.3024.7323zm-4.25873-8.05542c-.09074-.25749-.07439-.53948.04413-.7847.28283-.59424.72749-1.09613 1.2825-1.44924.555-.3523 1.1983-.54193 1.8563-.54521h.0213-.0009c.918.00327 1.7991.36211 2.4588.99966.6596.63839 1.0479 1.50646 1.0822 2.42357.0237.75284-.1962 1.49254-.6261 2.11054-.43.6188-1.0479 1.0814-1.7615 1.3209 0 0-.1022.036-.1022.0965v.8206h-.0008c0 .5681-.4602 1.0283-1.0283 1.0283s-1.0283-.4602-1.0283-1.0283v-.8206c.0098-.9319.6122-1.7542 1.4983-2.0443.6106-.2068 1.0144-.7888.994-1.43377-.0417-.78796-.6875-1.40919-1.4771-1.42064-.5607.00654-1.0683.33104-1.3078.83702-.179.38008-.57056.61305-.98989.58852-.41932-.0237-.78143-.3008-.91466-.69886z","fill":"#4a3428"}})])
          )
        }
      }
    